"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("./utils");
class CircleSvgComponent {
    constructor(snapCtx, position, dimensions) {
        this.snapCtx = snapCtx;
        this.position = position;
        this.dimensions = dimensions;
    }
    draw() {
        return new Promise((resolve) => {
            this.element = this.snapCtx.circle(this.position.x, this.position.y, this.dimensions.radius);
            // TODO: take in a given colour and calculate lighter value based on that
            const circleColourAttributes = {
                fillColour: '#d9c88c',
                strokeColour: '#e6dab3',
                strokeSize: 3,
            };
            utils_1.setColourAttributeForSnapElement(this.element, circleColourAttributes);
            resolve();
        });
    }
}
exports.CircleSvgComponent = CircleSvgComponent;
